import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "9",
  height: "13",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#a)" }, [
      _createElementVNode("path", {
        fill: "#053A41",
        d: "M8.827 2.146a.86.86 0 0 0-.096-1.145.712.712 0 0 0-1.057.104L4.5 5.231 1.327 1.105A.712.712 0 0 0 .27 1.001a.86.86 0 0 0-.096 1.145L3.524 6.5l-3.35 4.355A.86.86 0 0 0 .27 12a.712.712 0 0 0 1.057-.104L4.5 7.77l3.174 4.126A.712.712 0 0 0 8.73 12a.86.86 0 0 0 .096-1.145L5.477 6.5z"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h9v13H0z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }